import { useQuery, gql } from './graphql-provider';
import { Elm_Enum_Music_Mode, Elm_Enum_Music_Mode_Bool_Exp } from '../../../gen/types';

const MODES_QUERY = gql`
  query GetModes($where: elm_enum_music_mode_bool_exp) {
    modes: elm_enum_music_mode(where: $where) {
      value
      description
    }
  }
`;

export function useQueryModes({where}: {where: Elm_Enum_Music_Mode_Bool_Exp}) {
  const { loading, error, data } = useQuery<
    {modes: Array<Elm_Enum_Music_Mode>},
    {where: Elm_Enum_Music_Mode_Bool_Exp}
  >(MODES_QUERY, {
    variables: {where}
  });

  return {
    data: data ? data.modes : null,
    error,
    loading,
  };
}
